export const ACConfig = {
  apiUrl: '/api',
  emailRegex: /\S+@\S+\.\S+/,
  dateRegex: /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/, // only allows years between 1000 and 2999
};
